import type { Character } from "@/mocks/movies";

interface CharacterSectionProps {
  characters: Character[];
}

export default function CharacterSection({ characters }: CharacterSectionProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <h2 className="mb-2 flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-user-star-line" />
        </span>
        角色分析
      </h2>
      <p className="mb-5 text-sm text-foreground-500">
        重点角色介绍与深度解析，帮助你理解人物动机与命运走向。
      </p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {characters.map((character, index) => (
          <div
            key={character.name}
            className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-4"
          >
            <div className="flex items-center gap-3">
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-lg font-bold text-background-50 ${
                  index % 2 === 0 ? "bg-primary-600" : "bg-accent-500"
                }`}
              >
                {character.name.slice(0, 1)}
              </span>
              <div className="min-w-0">
                <h3 className="truncate text-base font-semibold text-foreground-950">
                  {character.name}
                </h3>
                <p className="truncate text-xs text-foreground-500">
                  饰演：{character.actor}
                </p>
              </div>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              {character.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}